import { render, staticRenderFns } from "./blue-flow-package-table.vue?vue&type=template&id=02d7d453&scoped=true"
import script from "./blue-flow-package-table.vue?vue&type=script&setup=true&lang=js"
export * from "./blue-flow-package-table.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d7d453",
  null
  
)

export default component.exports